import { defineNuxtPlugin, useRequestEvent } from '#app'
import { createCookieStore } from '../utils/cookieStore'

export default defineNuxtPlugin((nuxtApp) => {
  if (import.meta.server) {
    const event = useRequestEvent()
    if (!event?.node) {
      return
    }
    const { req, res } = event.node
    nuxtApp.provide('cookies', createCookieStore({ req, res }))
  } else {
    nuxtApp.provide('cookies', createCookieStore())
  }
})
